<template>
  <!--底部固定导航-->
  <div class="fixed-nav" id="footer" v-if="ENTRANCE !== 1">
    <slot></slot>
    <nav class="nav-list">
      <div class="item" :class="{ active: inx === 0 }" @click="toggleNav(0)">
        <svg-icon
          :name="'tabbar_icon_home_' + (inx === 0 ? (channel == '002_11_0000_0000_00' ? 'zx_sel' : getFirstNavSelIcon()) : (channel == '002_11_0000_0000_00' ? 'zx_def' : getFirstNavDefIcon()))">
        </svg-icon>
        <span>{{ getFirstNavName }}</span>
      </div>
      <div
        v-if="!isEntry"
        class="item"
        :class="{ active: inx === 1 }"
        @click="toggleNav(1)"
      >
        <!-- <img
          v-if="inx !== 1"
          class="img-examination"
          :src="require('@/assets/images/home/tabbar_icon_examination_def.png')"
        /> -->
        <svg-icon
          :name="'tabbar_icon_examination_' + (inx === 1 ? channel == '002_11_0000_0000_00' ? 'zx_sel' : 'sel' : (channel == '002_11_0000_0000_00' ? 'zx_def' : getSecondNavDefIcon()))"
        ></svg-icon>
        <span>{{ getSecondNavName }}</span>
      </div>
      <!-- <span
        class="item"
        :class="{ active: inx === 2 }"
        @click="toggleNav(2)"
      >
        <i></i>
      </span> -->
      <div class="item" :class="{ active: inx === 3 }" @click="toggleNav(3)">
        <!-- <img
          class="img-examination"
          :src="
            inx === 3
              ? require('@/assets/images/userCenter/tabbar_icon_mine_sel@2x.png')
              : require('@/assets/images/userCenter/tabbar_icon_mine_def@2x.png')
          "
          alt=""
          srcset=""
        /> -->
        <svg-icon
          :name="
            'tabbar_icon_mine_' +
              (inx === 3 ? (channel == '002_11_0000_0000_00' ? 'zx_sel' : 'sel') : (channel == '002_11_0000_0000_00' ? 'zx_def' : 'def'))
          "
        ></svg-icon>
        <span>我的</span>
      </div>
    </nav>
  </div>
</template>
<script>
import { isMiniProgram, toNucleicAcid } from '@/assets/js/util.js'
export default {
  name: "FixedNav",
  data() {
    return {
      // eslint-disable-next-line no-undef
      ENTRANCE,
      isEntry: sessionStorage.getItem("orgEntryInfo")
        ? sessionStorage.getItem("orgEntryInfo")
        : false,
      comefrom: sessionStorage.getItem("comefrom"),
      channel: sessionStorage.getItem("channel")
    };
  },
  props: {
    inx: {
      default: 0
    }
  },
  created() {
    if (this.$store.state.comefrom || sessionStorage.getItem("comefrom")) {
      // 第三方隐藏底部栏
      this.ENTRANCE = 1;
    }
  },
  computed: {
    getFirstNavName() {
      // return isMiniProgram() ? '体检' : '首页'
      return '首页'
    },
    getSecondNavName() {
      // return isMiniProgram() ? '核酸' : '体检'
      return '体检'
    }
  },
  methods: {
    getFirstNavSelIcon() {
      // return this.isWxMiniProgram() ? 'examination_sel' : 'sel'
      return 'sel'
    },
    getFirstNavDefIcon() {
      // return this.isWxMiniProgram() ? 'examination_def' : 'def'
      return 'def'
    },
    getSecondNavDefIcon() {
      // return this.isWxMiniProgram() ? 'nucleic_acid' : 'def'
      return 'def'
    },
    isWxMiniProgram() {
      return isMiniProgram()
    },
    // 页面切换
    toggleNav(inx) {
      switch (inx) {
        case 0:
          this.toIndex();
          break;
        case 1:
          this.toOrg();
          // if (this.isWxMiniProgram()) {
          //   toNucleicAcid(`${ZTPREFIX}?channel=006_88_1111_0004_00`)
          // } else {
          //   this.toOrg();
          // }
          break;
        // case 2:
        //   this.toReport();
        //   break;
        case 3:
          this.toMine();
          break;
      }
    },
    // 首页
    toIndex() {
      this.$router.push("/");
    },
    // 机构
    toOrg() {
      const params = "org";
      this.$router.push({ name: "package-org-list", params: { params } });
    },
    // 我的
    toMine() {
      this.$router.push("/user-center");
    },
    // 报告
    toReport() {
      this.$router.push("/report");
    }
  }
};
</script>

<style lang="less" scoped>
.fixed-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1999;
  width: 100%;
  // height: 98/200rem;//别写死
  border-top: 1px solid #dedede;
  box-sizing: content-box;
  background-color: #fff;

  .nav-list {
    display: flex;
    justify-content: space-between;
    padding: 10/200rem 100/200rem 12/200rem 102/200rem;

    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 58/200rem;
      height: 74/200rem;
      font-size: 20/200rem;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #303233;
      line-height: 22/200rem;
      svg,
      .img-examination {
        width: 48/200rem;
        height: 48/200rem;
      }
      &.active {
        color: #f58d25;
      }
    }
  }
}
.theme-zhongxin {
  .fixed-nav {
    .nav-list {
      .item {
        &.active {
          color: var(--color-theme);
        }
      }
    }
  }
}
</style>
